
export const date = (value, format) => {
  if (!value) {
    return ''
  }
  let date = new Date()
  if (typeof value === 'number') {
    // 转为时间
    date = new Date(value * 1000)
  } else if (typeof value === 'object') {
    date = value
  } else {
    value = value.replace('年', '-').replace('月', '').replace('日', ' ')
    date = _iosTime(value)
  }

  return _formatTime(date, format)
}
function _formatTime (_date, format) {
  let date = new Date()
  if ((typeof _date).toUpperCase() !== 'OBJECT') {
    date = new Date(_date)
  } else {
    date = _date
  }
  const year = date.getFullYear()
  const month = _formatNumber(date.getMonth() + 1)
  const day = _formatNumber(date.getDate())
  const hour = _formatNumber(date.getHours())
  const minute = _formatNumber(date.getMinutes())
  const second = _formatNumber(date.getSeconds())
  // 秒的时间戳
  if (format === '0') {
    return parseInt((date.getTime() / 1000) + '')
  }
  return format.replace('yyyy', year).replace('MM', month).replace('dd', day).replace('HH', hour).replace('mm', minute).replace('ss', second)
}
const _formatNumber = (n) => {
  n = n.toString()
  return n[1] ? n : '0' + n
}
const _iosTime = (dateObj) => {
  dateObj = dateObj.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').replace(/(-)/g, '/')
  if (dateObj.indexOf('.') > 0) dateObj = dateObj.slice(0, dateObj.indexOf('.'))
  return new Date(dateObj)
}



// WEBPACK FOOTER //
// ./src/components/utils/utils.js